module.exports = __webpack_public_path__ + "static/media/Rectangle 34.08921c6f.png";